import * as React from "react";
const SvgHeight = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M6 20V4H8V11L16 11V4H18V20H16V13L8 13V20H6Z", fill: "currentColor" }));
export default SvgHeight;
